import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'collected',
    lazy: async () => ({ Component: (await import('./CollectedPage')).CollectedPage }),
  },
];
